import Logger from './log';
import slsLogger from './sls-log';
/***
 * Notice: 不要试图在这里引入IMBaaSSDK和AuthService等, 容易造成循环引用
 */
const errorLog = new Logger('track');
errorLog.color('#872657'); // 草莓红
export default {
    error(name, params) {
        if (Object.prototype.toString.call(params) === '[object Object]') {
            params = stringify(params);
        }
        else {
            params = stringify({ params }); // 非object的参数构造出一个obj
        }
        errorLog.log(name, JSON.stringify(params));
        slsLogger.send({
            name,
            params
        });
    },
    // 本质上和error一样的逻辑, 做语义上区分
    info(name, params) {
        if (Object.prototype.toString.call(params) === '[object Object]') {
            params = stringify(params);
        }
        else {
            params = stringify({ params }); // 非object的参数构造出一个obj
        }
        errorLog.log(name, JSON.stringify(params));
        slsLogger.send({
            name,
            params
        });
    }
};
function stringify(json = {}) {
    return Object.keys(json)
        .map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    })
        .join('&');
}
